import React from 'react';
import { Container } from './ui/Container';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Mark',
  details: '52, Texas',
  quote: 'My wife moved to the couch because of my snoring. After 3 nights with SnoreStop™, we’re back in the same bed again.',
  image: 'https://i.pravatar.cc/150?img=12'
}, {
  name: 'David',
  details: '39, Florida',
  quote: 'I was embarrassed to travel because I snore so loud. First night using SnoreStop™, they didn’t hear a thing.',
  image: 'https://i.pravatar.cc/150?img=15'
}, {
  name: 'Linda',
  details: '47, California',
  quote: 'I was ready to divorce my husband over his snoring. Two weeks later, I finally sleep through the night.',
  image: 'https://i.pravatar.cc/150?img=47'
}, {
  name: 'James',
  details: '61, Arizona',
  quote: 'CPAP felt like torture. SnoreStop™ felt like freedom.',
  image: 'https://i.pravatar.cc/150?img=33'
}, {
  name: 'Maria',
  details: '44, New York',
  quote: 'We stopped fighting about sleep for the first time in 8 years.',
  image: 'https://i.pravatar.cc/150?img=44'
}, {
  name: 'Robert',
  details: '58, Oregon',
  quote: 'My partner finally wakes up rested again. Our relationship feels new.',
  image: 'https://i.pravatar.cc/150?img=13'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-white" data-id="element-487">
      {/* Lifestyle Banner */}
      <div className="w-full h-[300px] md:h-[400px] relative mb-16 overflow-hidden" data-id="element-488">
        <div className="absolute inset-0 bg-blue-900/40 mix-blend-multiply z-10" data-id="element-489"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent z-10" data-id="element-490"></div>
        <img src="https://cdn.magicpatterns.com/uploads/cES34sjBtDAJteDaKkFSUr/imgi_15_1747183934-Untitled_design_(19).png" alt="Happy couple sleeping" className="w-full h-full object-cover" data-id="element-491" />
        <div className="absolute inset-0 flex items-center justify-center z-20" data-id="element-492">
          <div className="bg-white/90 backdrop-blur-md px-8 py-4 rounded-full shadow-2xl border border-white/50" data-id="element-493">
            <p className="text-xl md:text-2xl font-bold text-gray-900 flex items-center" data-id="element-494">
              <Star className="w-6 h-6 text-orange-500 fill-current mr-3" data-id="element-495" />
              Join 10,000+ Couples Sleeping Peacefully
            </p>
          </div>
        </div>
      </div>

      <Container data-id="element-496">
        <div className="text-center mb-16" data-id="element-497">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-498">
            Real Couples. Real Results.
          </h2>
          <p className="text-xl text-gray-600" data-id="element-499">
            See why 10,000+ couples trust SnoreStop™
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-500">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-50 rounded-2xl p-8 shadow-sm border border-gray-100 flex flex-col h-full hover:shadow-md transition-shadow relative" data-id="element-501">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-blue-100 fill-current" data-id="element-502" />

              <div className="flex items-center space-x-1 text-orange-500 mb-6" data-id="element-503">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-504" />)}
              </div>

              <p className="text-gray-800 text-lg font-medium italic mb-8 flex-grow leading-relaxed" data-id="element-505">
                "{t.quote}"
              </p>

              <div className="flex items-center mt-auto border-t border-gray-200 pt-6" data-id="element-506">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 border-2 border-white shadow-sm" data-id="element-507">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover" data-id="element-508" />
                </div>
                <div data-id="element-509">
                  <p className="font-bold text-gray-900" data-id="element-510">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-511">{t.details}</p>
                </div>
              </div>
            </div>)}
        </div>
      </Container>
    </section>;
}